import { cssVars } from '@/lib/cssVars';
import { cx } from '@/lib/cx';
import { Icon } from './Icon';
import styles from './StarRating.module.css';

interface StarRatingProps {
  /** Stars earned, 0-3. */
  stars: number;
  /** Star size in design units. */
  size?: number;
  /** Pop the earned stars in one by one (mission results). */
  animate?: boolean;
  className?: string | undefined;
}

/** Three stars, earned ones lit; the accessible label says how many. */
export function StarRating({ stars, size = 18, animate, className }: StarRatingProps) {
  return (
    <span
      className={cx(styles.rating, animate && styles.animate, className)}
      role="img"
      aria-label={`${String(stars)} of 3 stars`}
      style={cssVars({ '--size': size })}
    >
      {[0, 1, 2].map((i) => (
        <Icon
          key={i}
          name={i < stars ? 'star' : 'starEmpty'}
          className={cx(styles.star, i < stars && styles.earned)}
          style={cssVars({ '--i': i })}
        />
      ))}
    </span>
  );
}
